<template>
  <div class="danmu-page">
    <div class="search-form">
      <el-form :inline="true" :model="searchForm" @submit.native.prevent="goSearch">
        <el-form-item label="用户名">
          <el-input v-model="searchForm.nn" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-col :span="11">
            <el-form-item class="begin-item">
              <el-date-picker :editable="false" type="datetime" placeholder="选择日期" v-model="searchForm.beginTime" style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2" style="text-align: center">-</el-col>
          <el-col :span="11">
            <el-form-item>
              <el-date-picker :editable="false" type="datetime" placeholder="选择日期" v-model="searchForm.endTime" style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item>
        <el-button type="primary" native-type='submit'>查询</el-button>
      </el-form-item>
      </el-form>
    </div>
    <div class="">
      <el-table
        v-loading="loading"
        :data="danmu.list"
        stripe
        style="width: 100%"
        :default-sort = "{prop: 'createdAt', order: 'descending'}"
        @sort-change="sortChange"
      >
        <el-table-column
          prop="nn"
          label="用户名"
        >
        </el-table-column>
        <el-table-column
          prop="txt"
          label="内容"
        >
        </el-table-column>
        <el-table-column
          prop="createdAt"
          label="创建时间"
          sortable="custom"
        >
          <template scope="scope">
            {{ timeFormat(scope.row.createdAt) }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination-inner"
        @current-change="handleCurrentChange"
        :current-page.sync="danmu.pageNum"
        :page-size="danmu.pageSize"
        layout="total, prev, pager, next, jumper"
        :page-count="danmu.pages"
        :total="danmu.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import api from '../api/api'
  import moment from 'moment'
  export default {
    name: 'main',
    data() {
      return {
        loading: false,
        searchForm : {
          nn: '',
          beginTime: '',
          endTime: '',
          pageNum: 1,
          short: -1
        },
        danmu : {}
      }
    },
    created () {
      this.getList();
    },
    methods: {
      getList (){
        this.loading = true;
        api.danmu.list(this.searchForm).then( (result) => {
          this.loading = false;
          this.danmu = result.data.res
        }).catch( () => {
          this.loading = false;
        })
      },
      timeFormat(val){
        return moment(val).format('YYYY-MM-DD HH:mm:ss')
      },
      handleCurrentChange(val){
        this.searchForm.pageNum = val;
        this.getList();
      },
      goSearch(){
        this.searchForm.pageNum = 1;
        this.getList();
      },
      sortChange(obj){
        if(obj.prop === 'createdAt'){
          if(obj.order === 'ascending'){
            this.searchForm.short = 1
          } else {
            this.searchForm.short = -1
          }
        }
        this.searchForm.pageNum = 1;
        this.getList();
      }
    }
  }
</script>
<style>
  .el-form--inline .el-form-item.begin-item {
    margin-right: 0;
  }
</style>



// WEBPACK FOOTER //
// main.vue?302a9896